import {
  AdminFetchDocusignPartnerTemplates,
  AdminFetchInsurancePolicies,
  AdminFetchLmsTrainingList,
  AdminFetchYardstikPackages,
} from 'src/constants/actionTypes'
import type { Action } from 'src/utils/reduxUtils'

/**
 * The flow editor's step-picker reference lists the signed-in user may read (ENG-1207 part 2).
 * Each GET has its own permission, so each is included independently; a skipped list leaves its
 * picker without options. The caller awaits exactly these, so it never waits on a request that
 * was not dispatched.
 */
export const buildCollectStepReferenceRequests = (
  customerId: string,
  access: {
    canViewDocusignTemplates: boolean
    canViewLmsTrainings: boolean
    canViewYardstik: boolean
    canViewInsurancePolicies: boolean
  },
): Array<Action<unknown>> => {
  const requests: Array<Action<unknown>> = []

  if (access.canViewDocusignTemplates) {
    requests.push(AdminFetchDocusignPartnerTemplates.request({ partnerId: customerId }))
  }

  if (access.canViewLmsTrainings) {
    requests.push(AdminFetchLmsTrainingList.request(undefined))
  }

  if (access.canViewYardstik) {
    requests.push(AdminFetchYardstikPackages.request({ partnerId: customerId }))
  }

  if (access.canViewInsurancePolicies) {
    requests.push(AdminFetchInsurancePolicies.request({ partnerId: customerId }))
  }

  return requests
}
